module.exports = "<h1>{{id}}</h1>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/search-grid-link-destination-example/search-grid-link-destination-example.component.html
// module id = ./src/app/components/examples/search-grid-link-destination-example/search-grid-link-destination-example.component.html
// module chunks = main